/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15 15v-2H1v2h14zM11.535 5.06L8.994 7.594 9.006 1h-2l-.012 6.594-2.53-2.534L3.05 6.474l4.944 4.949 4.955-4.95-1.414-1.413z" _fill="#006FBA"/>'
  }
})
